<ng-container *ngIf="visible">
  <div *ngIf="root && item.label == 'removetoplabels'">
    <span class="layout-menuitem-text" style="color: #1f4897"
      >{{ item.label }}</span
    >
  </div>
  <a
    [attr.href]="item.url"
    (click)="itemClick($event)"
    *ngIf="!item.routerLink || item.items"
    (keydown.enter)="itemClick($event)"
    [attr.target]="item.target"
    [attr.tabindex]="0"
    [ngClass]="item.class"
    (mouseenter)="onMouseEnter()"
    pRipple
    [pTooltip]="item.label"
    [tooltipDisabled]="active || !(root && app.isSlim() && !app.isMobile())"
  >
    <span class="backCss">
      <i
        [ngClass]="item.icon"
        class="layout-menuitem-icon"
        style="color: #1f4897"
      ></i>

      <span class="layout-menuitem-text"
        ><b>{{ item.label }}</b></span
      >

      <span
        class="p-badge p-component p-badge-no-gutter"
        [ngClass]="item.badgeClass"
        *ngIf="item.badge && !root"
        >{{ item.badge }}</span
      >

      <i
        class="pi pi-fw pi-angle-down layout-submenu-toggler"
        *ngIf="item.items"
      ></i>
    </span>
  </a>
  <a
    (click)="itemClick($event)"
    *ngIf="item.routerLink && !item.items"
    [routerLink]="item.routerLink"
    routerLinkActive="active-menuitem-routerlink"
    [routerLinkActiveOptions]="{ exact: true }"
    [attr.target]="item.target"
    [attr.tabindex]="0"
    [ngClass]="item.class"
    (mouseenter)="onMouseEnter()"
    pRipple
    [pTooltip]="item.label"
    [tooltipDisabled]="active || !(root && app.isSlim() && !app.isMobile())"
  >
    <span class="flex">
      <i
        [ngClass]="item.icon"
        class="layout-menuitem-icon"
        style="color: #1f4897"
      ></i>

      <span class="layout-menuitem-text ulListInner">{{ item.label }}</span>
      <span
        class="p-badge p-component p-badge-no-gutter"
        [ngClass]="item.badgeClass"
        *ngIf="item.badge && !root"
      >
        {{ item.badge }}
      </span>
      <i
        class="pi pi-fw pi-angle-down layout-submenu-toggler"
        *ngIf="item.items"
      ></i>
    </span>
  </a>
  <ul
    *ngIf="(item.items && root) || (item.items && active)"
    [@children]="
      root ? 'visible' : active ? 'visibleAnimated' : 'hiddenAnimated'
    "
  >
    <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
      <li
        app-menuitem
        [item]="child"
        [index]="i"
        [parentKey]="key"
        [class]="child.badgeClass"
      ></li>
    </ng-template>
  </ul>
</ng-container>
